import loadable from '@loadable/component';

export const getCollapsibleListData = loadable.lib(() =>
  import(
    /* webpackChunkName: "get-collapsible-list-faq-data" */
    '@wix/communities-blog-client-common/dist/src/services/get-collapsible-list-faq-data'
  ),
);
